export default __webpack_public_path__ + "static/media/card-profile1.ff301ade.jpg";